import React, { useEffect, useState } from "react";
import DTOAboutMe from "./DTOAboutMe";
import AboutMePresenter from "./AboutMePresenter";
import { aboutMeType } from "../../../../common/interfaces/myProfile/personalDetails/aboutMeType";
import { useAppSelector } from "../../../../infra/hooks";
import { useTranslation } from "react-i18next";

function AboutMeController() {
  const [aboutMe, setAboutMe] = useState<aboutMeType>({ about_me: "" });
  const [cardUpdate, setCardUpdate] = useState<boolean>(false);
  const { t, i18n } = useTranslation();

  function callBackFunc(data: aboutMeType) {
    setAboutMe(data);
  }
  const callBackCardUpdate = (card: boolean) => {
    setCardUpdate(card);
  };
  const hr_view = useAppSelector((state) => state.isHRViewSlice.HRView);
  return (
    <div>
      <DTOAboutMe setAboutMeData={callBackFunc} />
      <AboutMePresenter
        aboutMeData={aboutMe}
        isCardUpdate={callBackCardUpdate}
        hr_view={hr_view}
        trans={t}
      />
    </div>
  );
}

export default AboutMeController;
